import Swal from 'sweetalert2';

/** Por encima de MUI Dialog a pantalla completa (z-index ~1300); si no, los avisos quedan ocultos detrás. */
function ensureSwalAboveModals() {
	requestAnimationFrame(() => {
		const c = typeof document !== 'undefined' ? document.querySelector('.swal2-container') : null;
		if (c) c.style.zIndex = '20000';
	});
}

// Error messages from api returned as {message: 'error message text'}
export const logError = ({
	error,
	customMessage = 'No custom message from backoffice',
}) => {
	error?.response?.status
		? console.log(
				`ERROR\n 
					Status: ${error.response.status}.\n 
					Status error: ${error.response.statusText}.\n
					API Message: ${error.response.data?.message}\n
					Backoffice Message: ${customMessage}`
		  )
		: console.log(
				`ERROR\n 
					Backoffice message: ${customMessage}\n ${error}`
		  );
};

export const logFormData = (formData) => {
	console.group('FormData');
	for (let pair of formData.entries())
		console.log('key:', pair[0] + ', value: ' + pair[1]);

	console.groupEnd('FormData');
};

export const alertError = ({ error, customMessage }) => {
	console.log('alertError called');
	const message =
		error?.response?.data?.message ||
		error?.response?.statusText ||
		error ||
		customMessage ||
		'Error has no message';

	const params = {
		icon: 'error',
		title: (customMessage?.length < 30 && customMessage) || 'Ooops...',
		text: message,
		didOpen: ensureSwalAboveModals,
	};

	Swal.fire(params);
};

export const alertInfo = ({ customMessage } = {}) => {
	const params = {
		icon: 'info',
		title: 'Advice!',
		text: customMessage,
		didOpen: ensureSwalAboveModals,
	};

	return Swal.fire(params);
};

export const alertSuccess = ({ customMessage } = {}) => {
	console.log('alertSuccess called');
	const message = customMessage || 'Successfull operation!';

	const params = {
		icon: 'success',
		title: 'Ok!',
		text: message,
		didOpen: ensureSwalAboveModals,
	};

	return Swal.fire(params);
};
